import mapbox from "mapbox-gl";

// https://docs.mapbox.com/help/glossary/access-token/
mapbox.accessToken =
  "pk.eyJ1IjoiamFtZXNwYXRyaWNrZ2lic29uIiwiYSI6ImNrOWdieDBsMjBocWszZW8zMGxycTNvdnMifQ.5x9jjjVGujES1sb1yF6HVw";

const key = {};

export { mapbox, key };
